import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Lock } from "lucide-react";

export default function AdminLogin({ pin, setPin, onSubmit }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--mn-cream)] px-5">
      <motion.form
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        onSubmit={onSubmit}
        className="w-full max-w-md bg-white border border-[var(--mn-line)] rounded-[4px] p-8"
        data-testid="admin-login-form"
      >
        <div className="flex items-center gap-3 mb-6">
          <span className="w-10 h-10 inline-flex items-center justify-center bg-[var(--mn-gold)] text-white rounded-sm">
            <Lock size={18} />
          </span>
          <div>
            <div className="text-[0.7rem] uppercase tracking-[0.28em] text-[var(--mn-gold)] font-semibold">M NAIEF</div>
            <h1 className="font-serif-display font-extrabold text-2xl text-[var(--mn-black)] leading-tight">
              Painel Admin
            </h1>
          </div>
        </div>
        <p className="text-sm text-[var(--mn-dark)] leading-relaxed mb-6">
          Informe o PIN do administrador para acessar a galeria, orçamentos, contatos e newsletter.
        </p>
        <label className="mn-label" htmlFor="admin-pin">PIN do administrador</label>
        <input
          id="admin-pin"
          type="password"
          value={pin}
          onChange={(e) => setPin(e.target.value)}
          className="mn-input"
          placeholder="••••••••"
          data-testid="admin-pin-input"
          required
        />
        <button type="submit" className="btn-mn-primary w-full mt-6" data-testid="admin-login-submit">
          Entrar
        </button>
        <Link to="/" className="block text-center mt-5 text-xs uppercase tracking-[0.22em] text-[var(--mn-dark)] hover:text-[var(--mn-gold)]">
          ← Voltar ao site
        </Link>
      </motion.form>
    </div>
  );
}
